/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import {WealthyEnv} from "helpers";

const successStories = [
  {
    id: 1,
    managerName: "Shyam",
    date: "Since June 2021",
    avatar: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-success-stories-shyam-avatar-cropped.png`,
    description: "I am now following my passion for finance. I started by managing investments for my friends and family, but later I transitioned into a full-time Wealth Partner.",
    mainExperience: "Mutual Fund Distributor,",
    pastExperience: "Ex Tata Motors"
  },
  {
    id: 2,
    managerName: "Priya",
    date: "Since Sep 2020",
    avatar: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-success-stories-priya-avatar-cropped.png`,
    description: "No office, no targets, and no risk. It is the perfect opportunity for me. I'm earning by doing by what I love to do without the pressure of a job.",
    mainExperience: "Corporate Finance Professional",
    pastExperience: ""
  },
  {
    id: 3,
    managerName: "Sameer",
    date: "Since Aug 2020",
    avatar: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-success-stories-sameer-avatar-cropped.png`,
    description: "I love the platform and the support. The app has everything I need and it keeps getting better and better every month.",
    mainExperience: "IT Professional,",
    pastExperience: "Project Manager"
  },
  {
    id: 4,
    managerName: "Birendra",
    date: "Since Feb 2021",
    avatar: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-success-stories-birendra-avatar-cropped.png`,
    description: "Joined Wealthy Partner after working for a Bank for 14 years. Now I earn more than before and my clients are also Happy.",
    mainExperience: "Bank Manager,",
    pastExperience: "Ex Branch Manager"
  },
  {
    id: 5,
    managerName: "Nirban",
    date: "Since Sep 2020",
    avatar: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-success-stories-nirban-avatar-cropped.png`,
    description: "I upgraded myself from an Insurance Advisor to a Wealth Partner. Now I have Better product range, commission, and support",
    mainExperience: "Insurance Advisor,",
    pastExperience: "Ex PNB Metlife"
  },
  {
    id: 6,
    managerName: "Varun",
    date: "Since Feb 2020",
    avatar: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-success-stories-varun-avatar-cropped.png`,
    description: "I always advised people about money. Now, I am also earning from it. Now, wealthy partner is an extension of my work",
    mainExperience: "CWM<sup>®</sup>,AIM<sup>™</sup>,CFP<sup>CM</sup>",
    pastExperience: "Wealth Manager"
  }

];

export default successStories;
